import { render, staticRenderFns } from "./CustomerLabels.vue?vue&type=template&id=daba602c&"
import script from "./CustomerLabels.vue?vue&type=script&lang=js&"
export * from "./CustomerLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports